import { render, staticRenderFns } from "./VariationTag.vue?vue&type=template&id=f548c87c&scoped=true&"
import script from "./VariationTag.vue?vue&type=script&lang=js&"
export * from "./VariationTag.vue?vue&type=script&lang=js&"
import style0 from "./VariationTag.vue?vue&type=style&index=0&id=f548c87c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548c87c",
  null
  
)

export default component.exports